import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  signal,
  viewChild,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { LANDING_ASSETS } from "../../../landing.assets";

@Component({
  selector: "app-landing-dashboard-compare",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule],
  templateUrl: "./landing-dashboard-compare.component.html",
  styleUrls: ["./landing-dashboard-compare.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingDashboardCompareComponent {
  private readonly containerRef =
    viewChild.required<ElementRef<HTMLElement>>("compareContainer");

  private isDragging = false;

  readonly assets = LANDING_ASSETS;
  readonly sliderPosition = signal(52);

  setLightMode(): void {
    this.sliderPosition.set(100);
  }

  setDarkMode(): void {
    this.sliderPosition.set(0);
  }

  onModeToggle(mode: "light" | "dark"): void {
    if (mode === "light") {
      this.setLightMode();
      return;
    }

    this.setDarkMode();
  }

  isLightActive(): boolean {
    return this.sliderPosition() >= 50;
  }

  onHandlePointerDown(event: PointerEvent): void {
    event.preventDefault();
    this.isDragging = true;
    (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    this.updatePositionFromClientX(event.clientX);
  }

  @HostListener("window:pointerup")
  onWindowPointerUp(): void {
    this.isDragging = false;
  }

  @HostListener("window:pointermove", ["$event"])
  onWindowPointerMove(event: PointerEvent): void {
    if (!this.isDragging) {
      return;
    }

    this.updatePositionFromClientX(event.clientX);
  }

  onContainerClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).closest(".landing-compare__handle")) {
      return;
    }

    this.updatePositionFromClientX(event.clientX);
  }

  private updatePositionFromClientX(clientX: number): void {
    const container = this.containerRef().nativeElement;
    const rect = container.getBoundingClientRect();
    const next = ((clientX - rect.left) / rect.width) * 100;
    this.sliderPosition.set(Math.min(100, Math.max(0, next)));
  }
}
